import { IParamsByUrl } from '~types/search'

const clearAll = ({ urlParams }: { urlParams: IParamsByUrl }) => {
  const params = {
    searchTerm: urlParams.searchTerm,
    currentPage: 1,
  }

  return params
}

export default clearAll
